var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardCrashanalysisIssuedetailTracedataWifiIcon = function SvgNewcsDashboardCrashanalysisIssuedetailTracedataWifiIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_crashanalysis_issuedetail_tracedata_wifi_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M855 913h14v14h-14z",
    "data-name": "\\u77E9\\u5F62 403"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_crashanalysis_issuedetail_tracedata_wifi_icon_svg__a)",
    transform: "translate(-855 -913)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#393157",
    d: "M857.562 920.476a6.12 6.12 0 0 1 4.454-1.816 6.02 6.02 0 0 1 4.423 1.817l-1.251 1.283a4.53 4.53 0 0 0-6.375 0Zm2.532 2.562a2.733 2.733 0 0 1 3.813 0l-1.906 1.906ZM855 917.944a9.62 9.62 0 0 1 7.016-2.889 9.52 9.52 0 0 1 6.985 2.889l-1.285 1.282a8.127 8.127 0 0 0-11.438 0Z"
  }))));
};
export default SvgNewcsDashboardCrashanalysisIssuedetailTracedataWifiIcon;